import React from 'react'

const StiMain = () => {
  return (
    <div id='website-responsive' className=''>
    <div className='bg-img' style={{ backgroundImage:'url("sti-testing/STI-Testing-Banner-v1.webp")', height:'100%', width:'100%'}}>
        <div className='toxicology-text-padding'>
            <div className='-max-width display-none-1150'>
                <text className='fs-ss-42 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                STI / STD TESTING<br/>
                IN CHICAGO, IL
                </text>
            </div>

            <div className='-max-width display-block-1150'>
                <text className='fs-ss-32-4 text-montserrat fw-600 lh-1 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                STI / STD TESTING<br/>
                IN CHICAGO, IL
                </text>
            </div>
        </div>
    </div>
</div>
  )
}

export default StiMain